import { match } from '../utilities/ResolutionHandler';
import ModalTriggerComponent from './ModalTriggerComponent';

export default class SizeGuideTrigger extends ModalTriggerComponent {
  get SELECTORS() {
    return {
      desktopModal: '#js-size-guide-desktop',
      mobileModal: '#js-size-guide-mobile'
    };
  }

  open() {
    if (this.$options.element && !this.$options.close) {
      this.EMIT(this.CUSTOM_MESSAGES.MODAL_EVENTS.show, {
        selector: match('medium') ? this.SELECTORS.mobileModal : this.SELECTORS.desktopModal,
        className: this.$options.classname || ''
      });
    } else {
      this.EMIT(this.CUSTOM_MESSAGES.MODAL_EVENTS.close);
    }
  }
}
